import type { BillingProfileStepState } from "@/shared/hooks/useBillingProfileStep";
import { Dialog, DialogContent } from "@/shared/ui/dialog";
import { BillingProfileStep } from "./BillingProfileStep";

/**
 * The billing details step for a purchase that starts from a button rather than a dialog — "Add it" on a
 * locked panel, "Add a terminal" on a limit notice, "Pay now" on a re-issue. The step is the whole dialog,
 * so Back is Cancel; a save continues the purchase and its order dialog takes over from this one.
 */
export function BillingProfileDialog({ step, busy }: { step: BillingProfileStepState; busy?: boolean }) {
  return (
    <Dialog open={step.open} onOpenChange={(isOpen) => (!isOpen ? step.back() : undefined)}>
      <DialogContent>
        {step.open ? <BillingProfileStep step={step} busy={busy ?? false} backLabel="Cancel" /> : null}
      </DialogContent>
    </Dialog>
  );
}
